import { render, staticRenderFns } from "./RevenueTable.vue?vue&type=template&id=524e94e4&"
import script from "./RevenueTable.vue?vue&type=script&lang=js&"
export * from "./RevenueTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports